import { LOAD_DANDOS, LOAD_DANDO_INFO} from "./action";

const initialState = {
	currentDandOs: [],
	currentPage: 0,
	totalDandOs: 0,
	totalPages: 0,
	sortValue: '',
	sortOrder: ''
};

const reducer = (state = initialState, action) => {
	switch (action.type) {

		case LOAD_DANDOS:
			return {
				...state, 
				currentDandOs: action.dandos, 
				currentPage: action.currentPage, 
				totalDandOs: action.totalDandOs,
				totalPages: action.totalPages,
				sortValue: action.sortValue,
				sortOrder: action.sortOrder
			};
		case LOAD_DANDO_INFO:
	      return {
	        ...state,
	        DandOData: action.DandOData
	      };
		default:
			return state;
	}
};

export default reducer;


// WEBPACK FOOTER //
// ./src/components/Admin/storeDandO/reducer.js